<form [formGroup]="searchForm">
    <mat-form-field class="example-form-field">
        <mat-label>Rechercher</mat-label>
        <input matInput type="text" formControlName="research">
      </mat-form-field>
</form>
